import { TGetMatchResDto } from "@/api/services/main/match/dtos/get-match.dto";
import { TUpdateMatchReqDto, TUpdateMatchResDto } from "@/api/services/main/match/dtos/update-match.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export const fetchMatchInfoApi = async (): Promise<TGetMatchResDto> => {
  const rs = await clientApi.get<TGetMatchResDto>("/match");
  return rs.data;
};

export const useGetMatchInfo = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.MATCH.FETCH_DETAIL],
    queryFn: () => fetchMatchInfoApi(),
  });
};

/** Convert match payload to FormData for multipart file upload */
const buildMatchFormData = (payload: TUpdateMatchReqDto): FormData => {
  const formData = new FormData();
  const { matchLicenseFile, officeAppointmentFiles, matchOffices, ...rest } = payload;

  // Append scalar fields (send empty string for null file paths so backend clears them)
  Object.entries(rest).forEach(([key, value]) => {
    if (value === undefined) return;
    if (value === null) {
      formData.append(key, "");
      return;
    }
    formData.append(key, typeof value === "number" ? JSON.stringify(value) : String(value));
  });

  if (matchOffices) {
    formData.append("matchOffices", JSON.stringify(matchOffices));
  }

  if (matchLicenseFile) {
    formData.append("matchLicenseFile", matchLicenseFile);
  }
  if (officeAppointmentFiles?.length) {
    // Track which office index each file belongs to
    const indices: number[] = [];
    officeAppointmentFiles.forEach((file, index) => {
      if (file) {
        formData.append("officeAppointmentFiles", file);
        indices.push(index);
      }
    });
    if (indices.length > 0) {
      formData.append("officeAppointmentFileIndices", JSON.stringify(indices));
    }
  }

  return formData;
};

export const updateMatchApi = async (payload: TUpdateMatchReqDto): Promise<TUpdateMatchResDto> => {
  const formData = buildMatchFormData(payload);
  const rs = await clientApi.put<TUpdateMatchResDto>(`/match`, formData);
  return rs.data;
};

export const updateTutorialHiddenApi = async (isTutorialHidden: boolean): Promise<TUpdateMatchResDto> => {
  const rs = await clientApi.patch<TUpdateMatchResDto>(`/match/tutorial-hidden`, { isTutorialHidden });
  return rs.data;
};
